module.exports = __webpack_public_path__ + "static/media/PnJLogo.eb9faac8.png";